import styled, { css } from 'styled-components';

export const ReviewContainer = styled.div(
    ({ theme: { palette } }) => css`
        height: 100%;
        overflow-y: auto;

        scrollbar-color: rgba(${palette.neutral.black}, 0.4);
        scrollbar-width: thin;

        /* Styling the scrollbar in Chrome and Safari */
        &::-webkit-scrollbar {
            width: 10px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: rgba(
                ${palette.neutral.black},
                0.4
            ); /* Set thumb color for Chrome and Safari */
        }

        &::-webkit-scrollbar-track {
            background-color: rgba(
                ${palette.neutral.black},
                0.1
            ); /* Set track color for Chrome and Safari */
        }
    `,
);
